module.exports = __webpack_public_path__ + "img/4.0b97d37c.jpg";